export default function StartPlayingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="6.45 3.56 9.11 15.13">
      <g id="CaretRight">
        <path id="Vector" d="M15.3785 10.7278L7.19727 3.67238C6.89219 3.41027 6.44531 3.6466 6.44531 4.06984V18.1808C6.44531 18.604 6.89219 18.8403 7.19727 18.5782L15.3785 11.5228C15.6127 11.3208 15.6127 10.9298 15.3785 10.7278Z" fill="#333333" />
      </g>
    </svg>
  );
}
